import { lazy } from 'react';
import type { RouteObject } from 'react-router-dom';

const HomePage = lazy(() => import('../pages/home/page'));
const ServicesPage = lazy(() => import('../pages/services/page'));
const ProjectsPage = lazy(() => import('../pages/projects/page'));
const AboutPage = lazy(() => import('../pages/about/page'));
const QuotePage = lazy(() => import('../pages/quote/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/services',
    element: <ServicesPage />,
  },
  {
    path: '/projects',
    element: <ProjectsPage />,
  },
  {
    path: '/about',
    element: <AboutPage />,
  },
  {
    path: '/quote',
    element: <QuotePage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;